import { Component, Input, isDevMode } from '@angular/core';
import { CosmeticOptions } from '../../../models/filter-models';
import { MinimapIconSize } from "../../../models/enums";
import { assetBaseUrl } from '../../../../game';

@Component({
  selector: 'app-minimap-icon',
  imports: [],
  templateUrl: './minimap-icon.component.html',
  styleUrl: './minimap-icon.component.scss'
})
export class MinimapIconComponent {
  @Input() cosmeticOptions?: Partial<CosmeticOptions>;

  MinimapIconSize = MinimapIconSize;

  assetBaseUrl = assetBaseUrl;
}
